import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/consejo-de-asesores")({
  head: () => buildRouteHead("/es/consejo-de-asesores", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/sobre-qbd/consejo-asesor", replace: true });
  },
});
